<agr-dialog [data]="data" (cancel)="cancel()" class="edit-silo-dialog" data-test="edit-silo-dialog" (confirm)="createOrEditSilo()">
  <div [formGroup]="formGroup" class="spacing--margin-top">
    <mat-form-field data-test="edit-silo__silo-number" class="edit-silo-input">
      <mat-label>{{ 'edit-silo.silo-number' | translate }}</mat-label>
      <input data-test="edit-silo__sil-number-input" matInput #siloNumberInput formControlName="siloNumber" type="number" />
      <mat-error *ngIf="formGroup.controls.siloNumber.invalid" data-test="silo-number__error">{{ 'silos.number-error' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field data-test="edit-silo__silo-name" class="edit-silo-input">
      <mat-label>{{ 'edit-silo.silo-name' | translate }}</mat-label>
      <input data-test="edit-silo__sil-name-input" matInput #siloNameInput formControlName="siloName" />
      <mat-error *ngIf="formGroup.controls.siloName.invalid" data-test="silo-name__error">{{ 'silos.name-error' | translate }}</mat-error>
    </mat-form-field>
  </div>
</agr-dialog>
